/**
 * Presentation-only tidy-up of the raw operation label recorded on an undo
 * step ('margin', 'clearContoursOnSlice', 'Asymmetric Margin', 'boolean-or').
 *
 * The labels come from ~15 unrelated call sites of
 * `RegionOfInterest.startModify()` and have never shared a casing convention.
 * This normalises the SEPARATORS only — camelCase boundaries, hyphens and
 * underscores become spaces, and the first character is capitalised. Interior
 * casing is left exactly as recorded, so nothing the history list shows is a
 * word the code did not actually log: a mapping table would drift silently the
 * day a new operation is added, and lowercasing interior words would mangle
 * any acronym an operation picks up later.
 *
 * Returns '' for a blank label; the caller supplies the fallback wording.
 */
export const formatOperationLabel = (operation: string): string => {
    const spaced = operation
        .replace(/[-_]+/g, ' ')
        // Lower-to-upper boundary: 'clearContours' -> 'clear Contours'.
        // A digit before a capital is left alone, so '3D' stays a word.
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // Acronym-to-word boundary: 'SDFCopy' -> 'SDF Copy'.
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();

    if (spaced.length === 0) {
        return '';
    }
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
